module.exports = __webpack_public_path__ + "img/ic_12_down_highlight.743a2e6d.svg";